import type { SVGProps } from "react";
export interface BoxingIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BoxingIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BoxingIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.625 21a2.123 2.123 0 0 1-2.124 2.124H8A2.125 2.125 0 0 1 5.874 21v-3.659a1.125 1.125 0 1 1 2.25 0v3.533h2.304a2.26 2.26 0 0 0-.136-2.46l-.207-.257a1.126 1.126 0 0 1 1.675-1.487l.08.082.267.331a4.51 4.51 0 0 1 .728 3.791h2.538V17.5a1.126 1.126 0 0 1 2.25 0V21Z"
      />
      <path
        fill={color}
        d="M19.875 11c0-1.036-.84-1.875-1.875-1.875h-2.75c-.897 0-1.624.727-1.624 1.624l.007.167c.083.82.776 1.46 1.617 1.46h1.25l.115.005a1.125 1.125 0 0 1 0 2.239l-.115.006h-1.25a3.876 3.876 0 0 1-3.857-3.502H10A3.124 3.124 0 0 1 6.875 8V7a1.125 1.125 0 0 1 2.25 0v1c0 .483.392.875.875.875h1.86c.661-1.192 1.93-2 3.39-2h2.125V6A2.876 2.876 0 0 0 14.5 3.125H8A2.876 2.876 0 0 0 5.125 6v7c0 .96.113 1.467.245 1.773.12.28.292.482.634.783l.231.186a3.3 3.3 0 0 0 1.922.633H16.5c.928 0 1.549-.23 1.977-.515.435-.29.74-.684.954-1.113a4.4 4.4 0 0 0 .444-1.734zm-.25-3.792a4.13 4.13 0 0 1 2.5 3.792v2H21l1.125.001v.03l-.002.056a7 7 0 0 1-.083.801 6.7 6.7 0 0 1-.597 1.865 5.1 5.1 0 0 1-1.718 1.98c-.837.558-1.904.892-3.226.892H8.158a5.53 5.53 0 0 1-3.25-1.068l-.388-.31c-.444-.39-.904-.857-1.218-1.587-.302-.704-.426-1.555-.426-2.66V6A5.126 5.126 0 0 1 8 .875h6.5A5.126 5.126 0 0 1 19.625 6z"
      />
    </svg>
  );
}
